import React from 'react'
import { Label } from '@quest-lock/ui/label'
import { Bug, Lightbulb, Megaphone, MessageSquare } from 'lucide-react'

interface ContactTypeSelectorProps {
  value: string
  onSelect: (value: string) => void
  className?: string
}

const categories = [
  {
    label: 'Bug Report',
    value: 'error',
    icon: <Bug className="size-5 text-red-600" />
  },
  {
    label: 'Feature Suggestion',
    value: 'idea',
    icon: <Lightbulb className="size-5 text-amber-600" />
  },
  {
    label: 'Share a Testimonial',
    value: 'testimonial',
    icon: <Megaphone className="size-5 text-green-600" />
  },
  {
    label: 'General Feedback',
    value: 'other',
    icon: <MessageSquare className="size-5 text-blue-600" />
  }
]

const ContactTypeSelector: React.FC<ContactTypeSelectorProps> = ({
  value,
  onSelect,
  className
}) => {
  return (
    <div className={className}>
      <Label className="font-body">
        What would you like to contact us about?
      </Label>
      <div className="mt-3 grid grid-cols-1 gap-3 sm:grid-cols-2">
        {categories.map(cat => {
          const isSelected = value === cat.value
          return (
            <div
              key={cat.value}
              onClick={() => onSelect(cat.value)}
              className={`group flex min-h-[96px] cursor-pointer items-center justify-center gap-3 rounded-xl border-2 p-4 transition-all duration-200 sm:min-h-[120px] sm:p-5 ${
                isSelected
                  ? 'border-shire-sun bg-shire-sun/10 ring-shire-sun/30 ring-2'
                  : 'border-shire-bark/20 hover:border-shire-sun bg-white'
              }`}
            >
              <div className="mt-0.5 shrink-0">{cat.icon}</div>
              <div className="font-heading text-shire-dark text-center text-sm sm:text-base">
                {cat.label}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default ContactTypeSelector
